import type { StatItem } from 'src/types/content';

import { Reveal } from './reveal';

type StatsGridProps = {
  items: StatItem[];
};

export function StatsGrid({ items }: StatsGridProps) {
  return (
    <Reveal className="stats">
      {items.map((item) => (
        <div key={item.label} className="stat">
          <b>{item.value}</b>
          <span>{item.label}</span>
        </div>
      ))}
    </Reveal>
  );
}
